<coin-v2-country-flag
  [matTooltip]="language | translateLanguage"
  [matTooltipDisabled]="!showTooltip"
  [country]="languageIdentifier"
  [size]="size"></coin-v2-country-flag>
